import { render, staticRenderFns } from "./editWaybill.vue?vue&type=template&id=0ff46f12&scoped=true"
import script from "./editWaybill.vue?vue&type=script&lang=js"
export * from "./editWaybill.vue?vue&type=script&lang=js"
import style0 from "./editWaybill.vue?vue&type=style&index=0&id=0ff46f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff46f12",
  null
  
)

export default component.exports